/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint no-unused-vars : "off" */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import Modal from 'modules/common/components/Modal';
import LoginContainerModal from 'modules/auth/containers/LoginContainerModal';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import * as actions from 'modules/auth/actions';
import * as c from 'modules/auth/constants';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import SignUpModalNew from './SignUpModalNew';
import styles from './LogInModal.module.css';
import CmsContext from '../../../CmsContext';
import PinModalContainer from './PinModalContainer';

const form = {
  // email: 'taxpayer@email.com',
  // password: '123123123',
  mobile_number: '',
  password: '',
  profile_type: 'taxpayer',
};

function ForgotPasswordContainer({ forgotPassword, isLoading, history, serviceList }) {
  const cmsContext = useContext(CmsContext);
  const LOGOS = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const [isEmail, setIsEmail] = useState(false);
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const formValidator = useFormValidator(formData, {});

  useEffect(() => {
    if (isEmail) {
      formValidator.onSetObjectRules({
        email: 'required|email',
      });
    }
    if (!isEmail) {
      formValidator.onSetObjectRules({
        mobile_number: 'required|mobile_number_63',
      });
    }
  }, [isEmail]);

  const handleOpenAuthModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <SignUpModalNew />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleOnSubmit = (e) => {
    // /* eslint-disable */
    e.preventDefault();

    let payload;

    if (!isEmail) {
      payload = {
        email: formData.mobile_number,
        profile_type: formData.profile_type,
      };
    }

    if (isEmail) {
      payload = {
        email: formData.email,
        profile_type: formData.profile_type,
      };
    }

    forgotPassword(payload, () => {
      e.preventDefault();
      setModal({
        isOpen: true,
        content: <PinModalContainer mobileNo={payload.email} isEmail={isEmail} />,
        title: null,
        modalSize: 'modal-login',
        hideHeader: true,
        isCentered: true,
      });
    });

    // if (isEmail === true) {
    //   forgotPassword(formData, () => {
    //     history.push("/");
    //     setModal({ isOpen: false });
    //   });
    // }
    // if (isEmail === false) {
    //   const payload = {
    //     email: formData.mobile_number,
    //     profile_type: formData.profile_type,
    //   };

    //   forgotPassword(payload, () => {
    //     e.preventDefault();
    //     setModal({
    //       isOpen: true,
    //       content: <PinModalContainer mobileNo={payload.email} />,
    //       title: null,
    //       modalSize: "modal-login",
    //       hideHeader: true,
    //       isCentered: true,
    //     });
    //   });
    // }
  };

  const handleOpenPin = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PinModalContainer mobileNo='639275543679' />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleOnClose = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <LoginContainerModal />,
      title: null,
      modalSize: 'modal-lg',
      hideHeader: true,
      isCentered: true,
    });
  };

  return (
    <Modal.Body>
      <button type='button' className='close modal-close' onClick={handleOnClose}>
        <span aria-hidden='true'>&times;</span>
      </button>
      <div className={styles['login-container']}>
        <div className={styles['login-logo']}>
          <div>
            <img
              className='relative'
              src={
                _.get(LOGOS, 'MAIN_LOGO.cdnUrl', '') ||
                _.get(LOGOS, 'MAIN_LOGO', '') ||
                defaultPhoto
              }
              // src="/ilgu/logo.svg"
              alt=''
              width={120}
              height={35}
            />
          </div>
          <div className={styles['login-title']}>
            <div className={styles['login-welcome']}>Welcome!</div>
            <div className={styles['login-description']}>Forgot Password</div>
          </div>
        </div>
        <div className={styles['login-form-container']}>
          <div className={styles['login-form-field']}>
            <div className={styles['login-form-label']}>
              <div
                className={styles['login-form-label-text']}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>
                  {isEmail ? 'Email' : 'Mobile Number'}{' '}
                  {isEmail
                    ? formValidator.renderMessage('email')
                    : formValidator.renderMessage('mobile_number')}
                </span>
                <span
                  role='button'
                  tabIndex='0'
                  onClick={() => {
                    setIsEmail(!isEmail);
                    setFormData({ email: '' });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setIsEmail(!isEmail);
                      setFormData({ email: '' });
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: '#007bff',
                    fontSize: '12px',
                  }}
                >
                  {isEmail ? 'Use Mobile Number' : 'Use Email'}
                </span>
              </div>
            </div>
            <div className='form-mobile' style={{ width: '100%' }}>
              {isEmail ? (
                <input
                  className={`${styles['login-password-field']} full-input`}
                  type='email'
                  name='email'
                  value={_.get(formData, 'email') || ''}
                  placeholder='ex. sample@email.com'
                  autoComplete='off'
                  autoFocus
                  required
                  onChange={handleOnChange}
                />
              ) : (
                <FormInputMobile
                  disableDropdown={false}
                  autoComplete='off'
                  autoFocus
                  type='tel'
                  name='mobile_number'
                  onChange={setFormData}
                  value={formData.mobile_number || ''}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles['login-action-container']}>
          <button
            type='button'
            onClick={handleOnSubmit}
            disabled={isLoading || !formValidator.response.is_passed}
            className='w-full inline-block text-center rounded-md bg-slate-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
          >
            {isLoading && <i className='fa fa-spin fa-spinner' />} Next
          </button>
          <div
            className={styles['login-signup-here']}
            role='button'
            tabIndex='0'
            onClick={handleOpenAuthModal}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleOpenAuthModal();
              }
            }}
          >
            Don’t have account yet? <b>Sign up Here.</b>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ForgotPasswordContainer.propTypes = {
  forgotPassword: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  serviceList: PropTypes.instanceOf(Array).isRequired,
};

const removeENews = (res) => {
  const newArr = res.filter((d) => {
    return d.attributes.name !== 'E-News' && d.attributes.name !== 'E-Wallet';
  });
  return newArr;
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.FORGOT_PASSWORD) > -1,
  serviceList: removeENews(_.get(api, 'SERVICES/get_services', []).list || []),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ForgotPasswordContainer);
